import { parseCalendarDate } from "../calendarDate";
import { Comp, NormalizedDataPoint, SheetWithIndexes } from "../PreparedDataset";

export type V1FileData = SheetWithIndexes;

const columnIndexes = {
  address: 0,
  date: 1,
  price: 2,
};

export function sheetToFileV1Data(data: SheetWithIndexes): V1FileData {
  return data;
}

export function normalizeDataV1(
  data: V1FileData,
  outliers?: string[],
  comps?: Comp[],
): NormalizedDataPoint[] {
  return data.map((row) => {
    return {
      address: row.cells[columnIndexes.address],
      date: parseCalendarDate(row.cells[columnIndexes.date]),
      dateString: row.cells[columnIndexes.date],
      price: Number(row.cells[columnIndexes.price]),
      priceString: row.cells[columnIndexes.price],
      id: row.id,
      outlier: outliers && outliers.includes(row.id),
      comp: comps && comps.map((c) => c.id).includes(row.id),
    };
  });
}
